import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
function KPISection({ summary }) {
  return (
    <div className="row mb-4">

      <div className="col-md-3">
        <div className="card p-3 text-center">
          <h6>Active Clients</h6>
          <h3 className="gold-text">{summary.activeClients}</h3>
        </div>
      </div>

      <div className="col-md-3">
        <div className="card p-3 text-center">
          <h6>Active Projects</h6>
          <h3 className="gold-text">{summary.activeProjects}</h3>
        </div>
      </div>

      <div className="col-md-3">
        <div className="card p-3 text-center">
          <h6>Suppliers</h6>
          <h3 className="gold-text">{summary.suppliers}</h3>
        </div>
      </div>

      <div className="col-md-3">
        <div className="card p-3 text-center">
          <h6>Workers On Site</h6>
          <h3 className="gold-text">{summary.workersOnSite}</h3>
        </div>
      </div>

    </div>
  );
}

export default KPISection;
